import TagManager from 'react-gtm-module';

export const useSearchTag = ({ startDate, endDate, location, numGuests }) =>
  TagManager.dataLayer({
    dataLayer: {
      event: 'click_search_venue',
      category: 'UI Interaction',
      action: 'Click',
      label: 'Search',
      startDate,
      endDate,
      location,
      numGuests
    }
  });
